<template>
  <router-link
    :to="{ name: 'Orders', params: { orderNumber: this.params.value }}"
    class="text-blue-500 underline"
    :target="target"
  >
    {{ params.value }}
  </router-link>
</template>

<script>
export default {
  name: "CustomerOrdersOrderLink",
  computed: {
    target() {
      if(this.params.target)
        return this.params.target;
      return "_self";
    },
  },
};
</script>
